var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCanceled = function SvgCanceled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60802 12.0815L17.8988 4.99017C19.0319 4.33661 20.4242 4.33661 21.5572 4.99017L33.848 12.0815C34.0564 12.2011 34.0261 12.4946 33.8094 12.5983L20.1838 19.1141C19.8956 19.2519 19.5605 19.2519 19.2722 19.1141L5.64663 12.5983C5.42994 12.4946 5.3997 12.2011 5.60802 12.0815ZM20.9571 22.1565C20.9571 21.7496 21.1908 21.3789 21.5578 21.2034L35.3228 14.6206C35.4714 14.5495 35.6476 14.6353 35.6709 14.7984C35.6941 14.968 35.7061 15.1401 35.7061 15.3138V30C35.7061 30.0376 35.7055 30.0747 35.7044 30.1113C35.2953 30.0267 34.898 29.8484 34.5446 29.5707L32.7518 28.1622C29.8974 25.9194 26.215 29.4245 28.3736 32.3431C29.0039 33.1954 29.5578 33.9315 30 34.5C30.0631 34.5811 30.1257 34.6645 30.1878 34.7501L21.5572 39.7296C21.2777 39.8906 20.9571 39.6674 20.9571 39.3448V22.1565ZM18.499 22.1565C18.499 21.7496 18.2653 21.3789 17.8982 21.2034L4.59969 14.8436C4.21213 14.6583 3.75 14.8842 3.75 15.3138V29.406C3.75 30.7422 4.45896 31.9758 5.60802 32.6383L17.8988 39.7296C18.1783 39.8906 18.499 39.6674 18.499 39.3448V22.1565Z",
    fill: "#01cdfb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9971 31.0051L31.0071 42.9951",
    stroke: "#01cdfb",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 43.0025L31 31",
    stroke: "#01cdfb",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCanceled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/canceled.333f14e2.svg";
export { ForwardRef as ReactComponent };